import { Button } from "react-bootstrap";
import { setAgenciesLog } from "./service";

const AgencyElements = ({agencies, token}) => {

    const onClickTracker = (url) => (event) => {
        event.preventDefault();
        console.log("onClickTracker", url);
        setAgenciesLog(token, `Clicked on ${url}`);
        window.open(url, "_blank");
    };

    return(
    <>
        {agencies.map(({name, phone, link}) => (
            <div key={name}>
                <div style={{padding: "24px 32px",
                    fontFamily:"Arial,sans-serif",
                    fontSize: 15,
                    fontWeight: "normal",
                    color: "#696969",
                    borderRadius: 16,
                    backgroundColor: "#f2f4f4",}}
                >
                    <h2 style={{ margin: 0,
                        fontFamily: "Arial,sans-serif",
                        fontSize: 15,
                        fontWeight: "bold",
                        color: "#696969"}}>
                        {name}
                    </h2>
                    <p style={{ margin: "8px 0 0"}}>
                        <Button variant="link" className="link" onClick={onClickTracker(`tel:${phone}`)} rel="noreferrer"
                            style={{ color: "#00789e", textDecoration: "underline", padding: 0, }}>
                            <span style={{ color: "#00789e"}}>{phone}</span>
                        </Button>
                    </p>
                    {link && (
                        <p style={{margin: "8px 0 0"}}>
                            <Button variant="link" onClick={onClickTracker(link)} rel="noreferrer"
                                style={{ color: "#00789e", textDecoration: "underline", padding: 0,}}>
                                <span style={{ color: "#00789e"}}>{link}</span>
                            </Button>
                        </p>
                    )}
                    
                </div>
            </div>
        ))}
    </>
);

}

export default AgencyElements;